import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export enum ColumnWidth {
  MEDIUM = 200,
}

@Component({
  selector: 'app-key-value-collection',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './key-value-collection.component.html',
  styleUrl: './key-value-collection.component.css',
})
export class KeyValueCollectionComponent {
  @Input() collection!: { key: string; value: string | number }[];
  @Input() keyColumnWidth = ColumnWidth.MEDIUM;
}
